import "password-reveal.scss";
import $ from "jquery";

$(() => {
  $("input.password-reveal:password").each(function () {
    const $input = $(this).addClass("password-reveal-active");
    // Add icon to reveal password
    const $icon = $('<span class="icon-eye-open icon reveal"></span>');
    $icon.insertAfter($input);
    $icon.on("click", function () {
      if ($input.attr("type") === "password") {
        $input.attr("type", "text");
        $icon.removeClass("icon-eye-open").addClass("icon-eye-closed");
      } else {
        $input.attr("type", "password");
        $icon.removeClass("icon-eye-closed").addClass("icon-eye-open");
      }
    });
  });
});
